export default __webpack_public_path__ + "static/media/icon_ranking.90ae2491.svg";